import { useCallback, useMemo, useState } from 'react';
import { PinStatus } from '@lib/common';
export var usePin = function usePin(_ref) {
  var questions = _ref.questions,
      selectedSection = _ref.selectedSection,
      selectedSectionIndex = _ref.selectedSectionIndex,
      questionLabel = _ref.questionLabel,
      sectionLabel = _ref.sectionLabel;

  var _useState = useState(null),
      pinnedSectionId = _useState[0],
      setPinnedSectionId = _useState[1];

  var _useState2 = useState(null),
      pinnedQuestionId = _useState2[0],
      setPinnedQuestionId = _useState2[1];

  var _useState3 = useState(PinStatus["default"]),
      pinStatus = _useState3[0],
      setPinStatus = _useState3[1];

  var totalScore = useMemo(function () {
    if (questions && selectedSection) {
      return questions.filter(function (q) {
        return q.sectionId === selectedSection.id.toString();
      }).reduce(function (score, question) {
        return score + question.score;
      }, 0);
    }

    return 0;
  }, [questions, selectedSection]);
  var onCancelPin = useCallback(function () {
    setPinnedQuestionId(null);
    setPinnedSectionId(null);
    setPinStatus(PinStatus.unpin);
  }, []);
  var onPinQuestion = useCallback(function (questionId) {
    setPinnedQuestionId(questionId);
    setPinnedSectionId(null);
    setPinStatus(PinStatus.pinned);
  }, []);
  var onPinSection = useCallback(function (sectionId) {
    setPinnedQuestionId(null);
    setPinnedSectionId(sectionId);
    setPinStatus(PinStatus.pinned);
    var firstQuestionOfPinSection = questions === null || questions === void 0 ? void 0 : questions.find(function (q) {
      return q.sectionId === sectionId;
    });
    if (!firstQuestionOfPinSection) return;
    requestAnimationFrame(function () {
      var _document$getElementB;

      (_document$getElementB = document.getElementById(firstQuestionOfPinSection.id.toString())) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }, [questions]);
  var renderPinnedQuestionOrSection = useCallback(function () {
    if (!questions) return null;
    var pinnedQuestion = questions === null || questions === void 0 ? void 0 : questions.find(function (q) {
      return q.id.toString() === pinnedQuestionId;
    });
    var isSectionPinned = pinnedSectionId && (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.id.toString()) === pinnedSectionId;
    if (!pinnedQuestion && !isSectionPinned) return null;
    return {
      pinnedQuestion: pinnedQuestion,
      pinnedQuestionIndex: (pinnedQuestion === null || pinnedQuestion === void 0 ? void 0 : pinnedQuestion.index) || 0,
      isSectionPinned: isSectionPinned,
      questionLabel: questionLabel,
      sectionLabel: sectionLabel,
      selectedSection: selectedSection,
      selectedSectionIndex: selectedSectionIndex,
      totalScore: totalScore
    };
  }, [questionLabel, pinnedQuestionId, pinnedSectionId, selectedSection, selectedSectionIndex, sectionLabel, totalScore, questions]);
  return {
    pinnedSectionId: pinnedSectionId,
    pinnedQuestionId: pinnedQuestionId,
    pinStatus: pinStatus,
    setPinStatus: setPinStatus,
    onCancelPin: onCancelPin,
    onPinQuestion: onPinQuestion,
    onPinSection: onPinSection,
    renderPinnedQuestionOrSection: renderPinnedQuestionOrSection
  };
};